import { Options } from "./options";

export class Quicksharelinkexpiry {
  options:Options;
  }

 
